import React from "react";

import getConfig from "next/config";

import { NextSeo } from "next-seo";

import "../../assets/event-contents";
import TrackPage from "../../components/TrackPage";
import MainLayout from "../../layout/MainLayout";
import { SeoBaselineConfig } from "../../seo";
import NewsContentView from "../../views/NewsContentView";

const { serverRuntimeConfig } = getConfig();

export const getServerSideProps = async ({ params, res }) => {
  try {
    const eventCanonical = params.path?.join("/");
    const content = (
      await import(`../../assets/event-contents/${eventCanonical}`)
    ).default;

    res.setHeader("cache-control", "public, max-age=604800");
    return {
      props: { content: { ...content, canonical: `/event/${eventCanonical}` } },
    };
  } catch (err) {
    //* runs on server
    // eslint-disable-next-line no-console
    console.info(err);
    res.setHeader(
      "cache-control",
      `public, max-age=${serverRuntimeConfig.NEXT_PUBLIC_PAGE_ERROR_CACHE_SECONDS}`
    );
    return {
      notFound: true,
    };
  }
};

export default function Page({ content }) {
  const seoTitle = content.title;
  const seoDescription = content.description;
  const images = [
    {
      url: content.mainImage.src,
    },
  ];
  const canonical = `${SeoBaselineConfig.canonical}${content.canonical}`;

  return (
    <>
      <TrackPage />
      <NextSeo
        {...SeoBaselineConfig}
        title={seoTitle}
        description={seoDescription}
        canonical={canonical}
        openGraph={{
          ...SeoBaselineConfig.openGraph,
          title: seoTitle,
          url: canonical,
          description: seoDescription,
          images,
        }}
      />
      <NewsContentView {...content} />
    </>
  );
}

Page.getLayout = function getLayout(page) {
  return (
    <MainLayout
      contentSx={{
        height: "auto",
        paddingX: { xs: 0, sm: "5%", md: "10%" },
        backgroundColor: "#000",
        backgroundImage: "linear-gradient(to bottom, #5869ae9f 50%, #b38bd09f)",
      }}
    >
      {page}
    </MainLayout>
  );
};
